module.exports = __webpack_public_path__ + "img/connect-4.42d2d431.svg";